import {TOGGLE_WANTS_EMAIL} from '../_CONSTANTS';

export const toggle_Wants_Email = (wantsEmail) => {
    console.log("ACTION CREATOR toggle_Wants_Email was called wantsEmail: ", wantsEmail)

    return ({
        type: TOGGLE_WANTS_EMAIL,
        payload: {wantsEmail: wantsEmail}
    })
}